module.exports = __webpack_public_path__ + "static/media/service-blue.30815c73.svg";